import React, { useEffect } from 'react';
import CloseIcon from '../../../../../assets/icons/General/close.svg?react';
import '../index.css';

let startPosition = 0;
let currentPosition = 0;
let oldTranslateBy = 0;
let translateBy = 0;

interface BottomSheetProps {
  show: boolean;
  onHide: () => void;
  children: React.ReactNode;
}

function BottomSheet({ show, onHide, children }: BottomSheetProps) {
  const [translateStyle, setTranslateStyle] = React.useState('0');
  const [dragging, setDragging] = React.useState(false);

  const handleMouseDown = () => {
    setDragging(true);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const handleTouchStart = () => {
    setDragging(true);
    document.addEventListener('touchmove', handleTouchMove);
  };

  const handleTouchEnd = () => {
    setDragging(false);
    document.removeEventListener('touchmove', handleTouchMove);
    handleRelease();
  };

  const handleRelease = () => {
    if (translateBy <= oldTranslateBy && translateBy !== 0) {
      translateBy = 0;
      setTranslateStyle('0');
      onHide();
    } else {
      setTranslateStyle(`-100% - 20px`);
      translateBy = 0;
      oldTranslateBy = 0;
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    handleRelease();
  };

  const handleMove = (y: number) => {
    if (startPosition === 0 && currentPosition === 0) {
      startPosition = y;
    }

    let newPosition = startPosition - currentPosition;

    if (newPosition >= 0) {
      currentPosition = startPosition;
      newPosition = 0;
    }

    if (newPosition !== oldTranslateBy && newPosition !== translateBy) {
      oldTranslateBy = translateBy;
    }

    translateBy = newPosition;

    setTranslateStyle(`-100% - 20px - ${newPosition}px`);
    currentPosition = y;
  };

  const handleTouchMove = (e: any) => {
    e.preventDefault();
    const touch = e.touches[0] || e.changedTouches[0];
    const y = touch.pageY.toFixed(0);
    if (y !== currentPosition) {
      handleMove(touch.pageY.toFixed(0));
    }
  };

  const handleMouseMove = (e: any) => {
    const y = e.clientY;
    if (y !== currentPosition) {
      handleMove(e.clientY);
    }
  };

  const handleClose = () => onHide();

  const handleOverlayClick = () => onHide();
  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  return (
    <>
      {show && (
        <div
          className="bg-black-900/75 fixed inset-0 z-[90] h-full w-full backdrop-blur-xs"
          onClick={handleOverlayClick}
        />
      )}
      <div
        style={show ? { transform: `translateY(calc(${translateStyle}))` } : {}}
        className={`bottom-sheet z-[95] box-border overflow-hidden rounded-t-xl bg-white transition-all duration-300 ease-in-out ${
          show ? 'show' : ''
        }${dragging ? 'dragging' : ''}`}
      >
        {/*<div*/}
        {/*  className="bottom-sheet-grip absolute top-0 z-[99] w-full"*/}
        {/*  onTouchStart={handleTouchStart}*/}
        {/*  onTouchEnd={handleTouchEnd}*/}
        {/*  onMouseDown={handleMouseDown}*/}
        {/*>*/}
        {/*  /!*<div />*!/*/}
        {/*</div>*/}
        <button
          type="button"
          className={`hover:bg-black-100 active:bg-black-200 absolute top-[30px] right-6 z-30 inline-flex items-center rounded-lg p-2 outline-hidden transition-all duration-150`}
          onClick={handleClose}
        >
          <CloseIcon className="stroke-black-900 w-[14px]" />
        </button>

        <div className="bottom-sheet-content">{children}</div>
      </div>
    </>
  );
}

export default BottomSheet;
